import React, { useState } from "react"
import styles from './vlinks.module.css'
import {AiOutlinePlus} from 'react-icons/ai'



const Vlinks=()=>{

    const [addForm,setAddForm]=useState(false);

    const rotate ={transform:"rotate(45deg)"}
    
    return(
        <div className={styles.container}>
            <div className={styles.addvlink}>
            <AiOutlinePlus onClick={()=>setAddForm(!addForm)} style={addForm?rotate:{}} className={styles.addicon}/>
            </div>
            {addForm?
        <div className={styles.addLinkForm}>
            <input placeholder={"Enter Url"}/>
            <select placeholder={"select Link type"}>
                <option>Select Link Type</option>
                <option>Facebook</option>
                <option>instagram</option>
                <option>linked In</option>
                <option>SnapChat</option>
                <option>Medium</option>
            </select>
            <button>Add to Profile</button>
        </div>:""}

        <div className={styles.itemarea}> 

        <div className={styles.itemCon}>
            <img className={styles.img} alt="vlink" src="https://i.ibb.co/wRL677R/Group-4.png"/>
        </div>
        <div className={styles.itemCon}>
            <img className={styles.img}  alt="vlink" src="https://i.ibb.co/L04BhqW/Group-10.png"/>
        </div>
        <div className={styles.itemCon}>
            <img className={styles.img}   alt="vlink"src="https://i.ibb.co/mJL3bRN/Group-9.png"/>
        </div>
        <div className={styles.itemCon}>
            <img className={styles.img}   alt="vlink"src="https://i.ibb.co/h1nLkfB/Group-2.png"/>
        </div>
        <div className={styles.itemCon}>
            <img className={styles.img}   alt="vlink"src="https://i.ibb.co/X77KmSK/Group-7-1.png"/>
        </div>
        <div className={styles.itemCon}>
            <img className={styles.img}   alt="vlink"src="https://i.ibb.co/BwcMwxV/Group-8-2.png"/>
        </div>
        <div className={styles.itemCon}>
            <img className={styles.img}   alt="vlink"src="https://i.ibb.co/fMn1fSt/Group-5.png"/>
        </div>
        <div className={styles.itemCon}>
            <img className={styles.img}   alt="vlink"src="https://i.ibb.co/TL02yNk/Group-3.png"/>
        </div>
       
        </div>
        </div>
    )

}

export default Vlinks;